import avif640 from '@/assets/hero-dining-640.avif';
import avif1024 from '@/assets/hero-dining-1024.avif';
import avif1600 from '@/assets/hero-dining-1600.avif';
import webp640 from '@/assets/hero-dining-640.webp';
import webp1024 from '@/assets/hero-dining-1024.webp';
import webp1600 from '@/assets/hero-dining-1600.webp';
import jpg640 from '@/assets/hero-dining-640.jpg';
import jpg1024 from '@/assets/hero-dining-1024.jpg';
import jpg1600 from '@/assets/hero-dining-1600.jpg';

interface Props {
  alt: string;
  className?: string;
  /** Above-the-fold hero: eager + high priority. Defaults to true. */
  priority?: boolean;
}

const avifSet = `${avif640} 640w, ${avif1024} 1024w, ${avif1600} 1600w`;
const webpSet = `${webp640} 640w, ${webp1024} 1024w, ${webp1600} 1600w`;
const jpgSet = `${jpg640} 640w, ${jpg1024} 1024w, ${jpg1600} 1600w`;

export const HeroDiningPicture = ({ alt, className, priority = true }: Props) => (
  <picture>
    <source type="image/avif" srcSet={avifSet} sizes="100vw" />
    <source type="image/webp" srcSet={webpSet} sizes="100vw" />
    <img
      src={jpg1024}
      srcSet={jpgSet}
      sizes="100vw"
      alt={alt}
      className={className}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      fetchPriority={priority ? 'high' : 'auto'}
    />
  </picture>
);

export default HeroDiningPicture;
